export default __webpack_public_path__ + "d4abb2b691186fef22935956efcf075c.svg";